<template>
    <div>
        <div class="elementsOrder">
            <div v-for="(element, index) in elements" :class="{ elementOrder: true, borderTop: index > 0 && !element.parent_id && isElementVisible(element) }">

                <input type="hidden" :name="names + '[' + index + '][id]'" v-model="element.id">
                <input v-if="!disableAddChildren && element.parent_id" type="hidden" :name="names + '[' + index + '][parent_id]'" v-model="element.parent_id">
                <slot name="default-hidden-fields" :index="index"></slot>

                <div class="row" :class="itemRowClass">
                    <template v-for="(attr, attrKey) in keys">

                        <div v-if="attr != 'hidden' && !isElementKeyHidden(element, attrKey)" :class="getColumnWidth(attr, attrKey)">
                            <template v-if="attr == 'boolean'">
                                <div class="d-flex h-100 align-items-center">
                                    <div class="form-group form-group--inline" :data-validation="required ? 'required' : ''">
                                        <input type="checkbox" :name="names + '[' + index + '][' + attrKey + ']'" v-model="element[attrKey]" value="1" @keydown.enter.prevent :required="required" @change="onDataChanged">
                                        <label :for="names + '[' + index + '][' + attrKey + ']'">
                                            <slot :name="attrKey + '-label'"></slot>
                                        </label>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="form-group" :data-validation="required ? 'required' : ''">
                                    <label :for="names + '[' + index + '][' + attrKey + ']'">
                                        <slot v-if="$slots[attrKey + '-' + index + '-custom-label']" :name="attrKey + '-' + index + '-custom-label'"></slot>
                                        <slot v-else :name="attrKey + '-label'"></slot>
                                    </label>

                                    <template v-if="(unchangeable.indexOf(attrKey) !== -1) && (element.id !== -1) && (element.id !== '-1')">
                                        <span>{{ typeof attr === "string" ? element[attrKey] : attr[element[attrKey]] }}</span>
                                        <input type="hidden" :name="names + '[' + index + '][' + attrKey + ']'" :value="element[attrKey]">
                                    </template>

                                    <template v-else>
                                        <span v-if="attr == 'label'" v-html="element[attrKey]"></span>

                                        <input v-else-if="(attr == 'text') || (attr == 'fullwidth_text')" type="text" :name="names + '[' + index + '][' + attrKey + ']'" v-model="element[attrKey]"  @keydown.enter.prevent :required="required" @change="onDataChanged">

                                        <input v-else-if="attr == 'color'" type="color" :name="names + '[' + index + '][' + attrKey + ']'" v-model="element[attrKey]"  @keydown.enter.prevent :required="required" @change="onDataChanged">

                                        <input v-else-if="attr == 'number'" type="number" :name="names + '[' + index + '][' + attrKey + ']'" v-model="element[attrKey]"  @keydown.enter.prevent :required="required" @change="onDataChanged">

                                        <input v-else-if="attr == 'price'" type="number" step="0.01" :name="names + '[' + index + '][' + attrKey + ']'" v-model="element[attrKey]"  @keydown.enter.prevent :required="required" @change="onDataChanged">

                                        <div v-else-if="(attr == 'textarea') || (attr == 'fullwidth_textarea')">
                                            <input type="hidden" :name="names + '[' + index + '][' + attrKey + ']'" :value="element[attrKey]" />
                                            <vue-editor :id="names + '[' + index + '][' + attrKey + ']'" :name="names + '[' + index + '][' + attrKey + ']'" :editorToolbar="customToolbar" v-model="element[attrKey]" @change="onDataChanged"></vue-editor>
                                        </div>

                                        <template v-else-if="attr == 'picture'">
                                            <input type="hidden" :name="names + '[' + index + '][old_' + attrKey + ']'" :value="element['old_' + attrKey] ? element['old_' + attrKey] : element[attrKey]" :required="required" @change="onDataChanged">

                                            <file-uploader :name="names + '[' + index + '][' + attrKey + ']'" accept=".svg, .png, .jpg"
                                                           :stored="element['old_' + attrKey] ? element['old_' + attrKey] : element[attrKey]"
                                                           :label="labelUpload"
                                                           :label-switch="labelSwitch"
                                                           :show="element['old_' + attrKey] != null || element[attrKey] != null"
                                                           :element-id="+element.id"
                                                           :element-name="attrKey"
                                                           @picture-changed="onPictureChanged"
                                                           @picture-deleted="onPictureDeleted"
                                            ></file-uploader>
                                        </template>

                                        <template v-else-if="attr == 'pdf'">
                                            <input type="hidden" :name="names + '[' + index + '][old_' + attrKey + ']'" :value="element['old_' + attrKey] ? element['old_' + attrKey] : element[attrKey]" :required="required" @change="onDataChanged">

                                            <file-uploader :name="names + '[' + index + '][' + attrKey + ']'" accept="application/pdf"
                                                           :stored="element['old_' + attrKey] ? element['old_' + attrKey] : element[attrKey]"
                                                           :label="labelUpload"
                                                           :label-switch="labelSwitch"
                                                           :show="element['old_' + attrKey] != null || element[attrKey] != null"
                                                           :element-id="+element.id"
                                                           :element-name="attrKey"
                                                           @picture-changed="onPictureChanged"
                                                           @picture-deleted="onPictureDeleted"
                                            ></file-uploader>
                                        </template>

                                        <input v-else-if="attr == 'date'" type="date" :name="names + '[' + index + '][' + attrKey + ']'" v-model="element[attrKey]" @keydown.enter.prevent :required="required" @change="onDataChanged">

                                        <input v-else-if="attr == 'time'" type="time" :name="names + '[' + index + '][' + attrKey + ']'" v-model="element[attrKey]" @keydown.enter.prevent :required="required" @change="onDataChanged">

                                        <div v-else class="input-group input-group--append">
                                            <select  :name="names + '[' + index + '][' + attrKey + ']'" v-model="element[attrKey]" @keydown.enter.prevent :required="required" @change="onDataChanged">
                                                <option v-for="opt in validOptions(attrKey, attr, index)" :value="opt[0]" :selected="element[attrKey] == opt[0]">{{ opt[1] }}</option>
                                            </select>
                                            <div class="input-group__icon">
                                                <svg viewBox="0 0 24 24">
                                                    <use xlink:href="#chevron-down"></use>
                                                </svg>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>

                        <input v-else type="hidden" :name="names + '[' + index + '][' + attrKey + ']'" v-model="element[attrKey]">
                    </template>

                    <div v-if="!disableDelete && isElementVisible(element)" class="col-md-2 elementOrder__actions">
                        <button type="button" class="btn-medium-grey elementOrder__delete" @click="deleteElement(index)">
                            <slot name="delete-label"></slot>
                        </button>
                    </div>
                    <div v-if="!disableAddChildren && isElementVisible(element) && isLastChild(element, index)" class="col-md-2 elementOrder__actions">
                        <button type="button" class="elementOrder__add btn-blue" @click="addChildElement(element, index)">
                            <slot name="add-label"></slot>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <button v-if="showAdd() && !disableAdd" type="button" class="btn-blue" @click="addElement">
                <slot name="add-label"></slot>
            </button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .ql-editor blockquote,
    .ql-editor h1,
    .ql-editor h2,
    .ql-editor h3,
    .ql-editor h4,
    .ql-editor h5,
    .ql-editor h6,
    .ql-editor ol,
    .ql-editor p,
    .ql-editor pre,
    .ql-editor ul {
        white-space: pre-wrap;
        word-break: break-all;
    }

    .elementsOrders--separation .elementOrder:not(:first-child) {
        border-top: 1px solid #dfdfdf;
    }

    .elementsOrders--colAauto {

        .col-md-3 {
            max-width: none;
            flex: 0 0 15%;
            margin-right: 30px;
        }

        .elementOrder__actions {
            margin-left: auto;
        }
    }

    .elementsOrders--2col {

        .col-md-3,
        .col-md-4,
        .col-md-5 {
            max-width: none;
            flex: 0 0 50%;
        }

        .elementOrder__actions {
            flex-basis: 100%;
            max-width: none;
            visibility: visible;
            justify-content: flex-start;
            margin-bottom: 18px;
        }
        .elementOrder__delete {
            transform: none;
        }
        .elementOrder__add {
            transform: none;
        }
    }

    .elementsOrders--noHover {
        .elementOrder__actions {
            flex-basis: 100%;
            max-width: none;
            visibility: visible;
            justify-content: flex-start;
            margin-bottom: 18px;
        }
        .elementOrder__delete {
            transform: none;
        }
        .elementOrder__add {
            transform: none;
        }
    }

    .elementOrder__delete {
        /* fix vertical alignement */
        transform: translateY(15px);
    }
    .elementOrder__add {
        /* fix vertical alignement */
        transform: translateY(15px);
    }

    .borderTop {
        border-top: 1px solid #dfdfdf;
        margin-top: 1em;
    }

</style>

<script>
    import Wysiwyg from './Wysiwyg.vue';
    import FileUploader from "./FileUploader";
    import { VueEditor } from 'vue2-editor';

    export default {
        components: {
            'Wysiwyg': Wysiwyg,
            'file-uploader': FileUploader,
            'vue-editor': VueEditor
        },
        props: {
            disableDelete: {
                type: Boolean,
                default: false
            },
            disableAdd: {
                type: Boolean,
                default: false
            },
            disableAddChildren: {
                type: Boolean,
                default: true
            },
            hiddenKeysFieldName: {
                type: String,
                default: 'hiddenKeys'
            },
            elementsName: String,
            oldElements: {
                type: Array,
                default: () => []
            },
            defaultChildHiddenKeys: {
                type: Array,
                default: () => []
            },
            elementKeys: {
                type: Object,
            },
            labelUpload: {
                type: String,
                default: 'Ajouter un fichier'
            },
            labelSwitch: {
                type: String,
                default: 'Remplacer le fichier'
            },
            unchangeableKeys: {
                type: Array,
                default: () => []
            },
            uniqueKeys: {
                type: Array,
                default: () => []
            },
            newOnDelete: {
                type: Boolean,
                default: true
            },
            reversed: {
                type: Array,
                default: () => []
            },
            required: {
                type: Boolean,
                default: false
            },
            allowEmpty: {
                type: Boolean,
                default: false
            },
            keysColumnSize: {
                type: Object,
                default: null
            },
            itemRowClass: {
                type: String,
                default: ''
            },
            maxRows: {
                type: Number,
                default: null
            },
        },
        data() {
            return {
                elements: this.oldElements,
                removedElements: [],
                keys: this.elementKeys,
                names: this.elementsName,
                unchangeable: this.unchangeableKeys,
                unique: this.uniqueKeys,
                customToolbar: [
                    ['bold', 'italic', 'underline'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    //['image', 'code-block']
                ]
            }
        },
        methods: {
            getColumnWidth(attr, attrKey) {
                if (this.keysColumnSize && this.keysColumnSize[attrKey]) {
                    return 'col-md-' + this.keysColumnSize[attrKey];
                }
                return attr == 'fullwidth_text' || attr == 'fullwidth_textarea'
                    ? 'col-md-12'
                    : (attr == 'text' || attr == 'date'
                        ? 'col-md-3'
                        : (attr == 'textarea'
                            ? 'col-md-5'
                            : ((attr == 'label' && (element[attrKey] == '' || element[attrKey] == null))
                                ? ''
                                : 'col-md-3')))
            },
            isElementKeyHidden (element, key) {
                if (this.hiddenKeysFieldName && element.hasOwnProperty(this.hiddenKeysFieldName)) {
                    return element[this.hiddenKeysFieldName].includes(key);
                }
                return false;
            },
            isElementVisible (element) {
                for (const key of Object.keys(this.keys)) {
                    if (!this.isElementKeyHidden(element, key)) {
                        return true;
                    }
                }
                return false;
            },

            showAdd() {
                if (this.maxRows !== null && this.maxRows <= this.elements.length) {
                    return false;
                }
                else if (this.unique.length === 0) {
                    return true;
                }
                else {
                    return (
                        this.unique.reduce((sum, entry) => {
                            sum += this.elements.map(element => Number.isNaN(parseInt(element[entry])) ? element[entry] : parseInt(element[entry])).filter(item => (item === "")).length;
                            return sum;
                        }, 0) === 0
                        &&
                        this.unique.reduce((sum, entry) => {
                            sum += this.validOptions(entry, this.keys[entry], -1).size;
                            return sum;
                        }, 0) > 0);
                }

            },
            validOptions(key, options, index) {
                if (this.unique.indexOf(key) > -1) {
                    let entries = Object.entries(options);
                    if (this.reversed.indexOf(key) > -1) {
                        entries.sort((a, b) => { return a[1].localeCompare(b[1]) });
                    }
                    return entries.filter(opt => {
                            let optIndex = this.elements.map(element =>
                                Number.isNaN(parseInt(element[key])) ? element[key] : parseInt(element[key])
                            ).indexOf(Number.isNaN(parseInt(opt[0])) ? opt[0] : parseInt(opt[0]));

                            return (optIndex === -1) || (optIndex === index);
                        }
                    )
                        .reduce((map, obj) => {
                            map.set(obj[0], obj[1]);
                            return map;
                        }, new Map());
                }
                else {
                    let entries = Object.entries(options);
                    if (this.reversed.indexOf(key) > -1) {
                        entries.sort((a, b) => { return a[1].localeCompare(b[1]) });
                    }

                    return entries.reduce((map, obj) => {
                        map.set(obj[0], obj[1]);
                        return map;
                    }, new Map());
                }
            },
            addElement() {
                var newObj = {id: -1};

                for (var propName in this.keys) {
                    newObj[propName] = '';
                }

                this.elements.push(newObj);
            },
            addChildElement(element, index) {
                var newObj = {id: -1, parent_id: element.parent_id ?? element.id};

                for (var propName in this.keys) {
                    newObj[propName] = '';
                }

                newObj[this.hiddenKeysFieldName] = this.defaultChildHiddenKeys;

                this.elements.splice(index + 1, 0, newObj);
            },
            isLastChild(element, index) {
                return (
                    //no child
                    (
                        !element.parent_id &&
                        this.elements.filter(elem => elem.parent_id === element.id).length === 0
                    )
                    ||
                    //no bro after itself
                    (
                        element.parent_id &&
                        this.elements.slice(index + 1).filter(elem => elem.parent_id === element.parent_id).length === 0
                    )
                )
            },
            deleteElement(index) {
                this.elements.splice(index, 1);
                if (this.elements.length === 0 && this.newOnDelete) {
                    this.addElement();
                }
            },
            onDataChanged() {
                //console.log(JSON.stringify(this.elements));
                this.$emit('data-changed', this.elements);
            },
            onPictureChanged(event) {
                this.elements.forEach((element) => {
                    if (element.id == event[0]) {
                        element[event[1]] = event[2];
                    }
                });
            },
            onPictureDeleted(event) {
                this.elements.forEach((element) => {
                    if (element.id == event[0]) {
                        element[event[1]] = '';
                    }
                });
            }
        },
        watch: {
            elementKeys: {
                // the callback will be called immediately after the start of the observation
                immediate: false,
                handler (val, oldVal) {
                    this.keys = val;
                    //Put back the removed elements in case a old key has been added back
                    this.removedElements.forEach(element => {
                        this.elements.push(element);
                    });

                    this.removedElements = [];

                    //Remove element not matching the new keys
                    for (let attr in val) {
                        if (typeof val[attr] == "object") {

                            //If the element contains a property than is not available anymore, we store it in the removed list
                            this.elements.forEach((element, index) => {
                                if (!this.allowEmpty && !(val[attr].hasOwnProperty(element[attr]))) {
                                    this.removedElements.push(element);
                                }
                                else if (this.allowEmpty && (element[attr] !== "") && (element[attr] != null) && !(val[attr].hasOwnProperty(element[attr]))) {
                                    this.removedElements.push(element);
                                }
                            });
                            //We remove the elements from the element list
                            this.removedElements.forEach(elementToRemove => {
                                let indexToRemove = this.elements.indexOf(elementToRemove);
                                if (indexToRemove !== -1) {
                                    this.deleteElement(indexToRemove);
                                }
                            });
                        }
                    }
                }
            }
        }
    }
</script>
